// Client-issued conversation id, persisted in localStorage so it survives page
// reloads. Server validates the UUID shape and issues its own if absent.
const KEY = "cmwConversationId";
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function generateUuid() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    let r;
    if (typeof crypto !== "undefined" && crypto.getRandomValues) {
      r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
    } else {
      r = Math.floor(Math.random() * 16);
    }
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getConversationId() {
  let id = "";
  try {
    id = localStorage.getItem(KEY) || "";
  } catch (e) {
    /* storage unavailable */
  }
  if (!UUID_RE.test(id)) {
    id = generateUuid();
    try {
      localStorage.setItem(KEY, id);
    } catch (e) {
      /* storage unavailable */
    }
  }
  return id;
}
